/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function CaretRightIcon(props: IconProps) {
    return <IconWrapper {...props}>{<path d="M14 11.992V27.97c0 1.817 2.179 2.695 3.424 1.441l7.969-7.958c.81-.752.81-2.068 0-2.82l-7.969-7.958C16.18 9.296 14 10.174 14 11.992"/>}</IconWrapper>;
}
